import enrollmentList from '@/store/modules/enrollment/enrollment-list'
import enrollmentInfo from '@/store/modules/enrollment/enrollment-info'
import enrollmentDocuments from '@/store/modules/enrollment/enrollment-documents'

export default {
  enrollmentList,
  enrollmentInfo,
  enrollmentDocuments,
}
